import React, { useState, useEffect, useRef } from "react";
import { FaArrowRight } from "react-icons/fa6";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  /*   zavření menu kliknutím mimo */
  useEffect(() => {
    if (!isOpen) return;
    const handleOutsideClick = (event) => {
      const menu = menuRef.current;
      const hamburger = hamburgerRef.current;
      if (
        menu &&
        hamburger &&
        !menu.contains(event.target) &&
        !hamburger.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <header>
      <nav className="navbar-wrapper">
        <div className="nav">
          <div className="logo">
            <a href="#hero">
              <img
                src="/navbar-logo.svg"
                alt="SESTAV HB s.r.o."
                width={300}
                height={29}
                fetchPriority="high"
              />
            </a>
          </div>
          <div ref={menuRef} className={`menu ${isOpen ? "open" : ""}`}>
            <a href="#services" onClick={closeMenu}>
              <span>Služby</span>
              <FaArrowRight className="nav-arrow" />
            </a>
            <a href="#galery" onClick={closeMenu}>
              <span>Projekty</span>
              <FaArrowRight className="nav-arrow" />
            </a>
            <a href="#contact" onClick={closeMenu}>
              <span>Kontakt</span>
              <FaArrowRight className="nav-arrow" />
            </a>
          </div>
          <button
            ref={hamburgerRef}
            className={`hamburger ${isOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label={isOpen ? "Zavřít menu" : "Otevřít menu"}
            aria-expanded={isOpen}
          >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
